import { apiPut, apiPatch } from '../../utils/api';
import { boardBaselineCanEdit } from '../teams/taskEditBaseline';

/**
 * A gag's task planning has TWO charts — the gag panel's task Gantt
 * (`GagDetailPanel.js`) and the Breakdown Timeline's expanded gag rows
 * (`GagTimelineView.js`). This is the part they must not each write for
 * themselves: the two schedule WRITES and the question "may this viewer change
 * this gag's tasks". Import from here in both; never retype a route or a gate.
 *
 * 🔑 Nothing here DECIDES authority. The gate reads the server's
 * `can_edit_tasks` off the gag DETAIL payload (`GET /api/gags/:gagId`, computed
 * by `helpers/gagTeamAccess.js`), strictly `=== true` so an older payload fails
 * closed. The server refuses independently either way.
 */

/** Gantt reschedule of one gag task: exactly the two dates, nothing else. */
export const rescheduleGagTask = (gagId, taskId, startDate, dueDate) => apiPut(
  `/api/gags/${gagId}/tasks/${taskId}`,
  { start_date: startDate, due_date: dueDate },
);

/** Move ONE gag date (`MILESTONE_DEFS` field: shoot / access / prep / strike). */
export const moveGagDate = (gagId, field, value) => apiPatch(
  `/api/gags/${gagId}/dates`,
  { field, value },
);

/**
 * The per-task edit predicate the task board takes: the server's rule 1
 * (owner · team · breakdown rights, reported as `can_edit_tasks`) OR the task's
 * own creator (owner ruling 2026-10-02).
 * 🪤 A missing viewer id must not "match" a task with no creator
 * (`undefined === undefined`), so the creator arm needs a real id on both sides.
 */
export function gagTaskEditPredicate(detail, userId) {
  const canEditTasks = !!detail && detail.can_edit_tasks === true;
  return (task) => canEditTasks
    || (userId != null && task.created_by != null && task.created_by === userId);
}

/**
 * May this viewer DRAG this gag's task bars? The board's own baseline of the
 * predicate above (`teams/taskEditBaseline.js`) — the same composition
 * the panel's Gantt runs, so the two charts cannot offer different drags.
 * ⚖️ That baseline is the server's flag ALONE: a creator-only viewer edits their
 * task in the List and gets no Gantt drag in either chart (ruled 2026-10-12:
 * mirror the panel exactly).
 */
export const gagTaskDragAllowed = (detail, userId) => boardBaselineCanEdit(gagTaskEditPredicate(detail, userId));
